import api from "../../api/core/api";
import pdfDesignApi from "../../api/pdfDesign/pdfDesignApi";
import quotationPdfApi from "../../api/pdf/quotationPdf.api";
import { PdfDocumentDesignDTO, PdfTemplateStyleCode } from "../../types/pdfDesign/pdfDesign";

const PdfDesignService = {
  /**
   * 🔹 Diseño actual + catálogo de estilos disponibles para un tipo
   * de documento (p. ej. "QUOTATION").
   * GET /api/pdf-designs/{kind}
   */
  getDesign: async (kind: string): Promise<PdfDocumentDesignDTO> => {
    const response = await pdfDesignApi.fetchCustom(`/${kind}`);
    return response.data;
  },

  /**
   * 💾 Actualiza el estilo seleccionado para un tipo de documento.
   * PUT /api/pdf-designs/{kind}
   */
  updateDesign: async (
    kind: string,
    style: PdfTemplateStyleCode
  ): Promise<PdfDocumentDesignDTO> => {
    const response = await api.put(`/pdf-designs/${kind}`, { style });
    return response.data;
  },

  /**
   * 👁️ Vista previa en vivo (HTML) de un diseño de cotización, con
   * una cotización de ejemplo. No persiste nada.
   * GET /api/pdf/quotations/preview-template?style=X
   */
  previewQuotationTemplate: async (style: PdfTemplateStyleCode): Promise<string> => {
    const response = await quotationPdfApi.fetchCustom(`/preview-template?style=${style}`);
    return response.data;
  },
};

export default PdfDesignService;
